import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import $axios from './services/api-koperasi'

declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

window.Pusher = Pusher

const echo = new Echo({
  broadcaster: 'pusher',
  key: 'b6f721bd4d20dbc15cd5',
  cluster: 'ap1',
  encrypted: true,
  // wsHost: window.location.hostname,
  // wsPort: 6001,
  // forceTLS: false,
  // disableStats: true,
  // enabledTransports: ['ws'],
  // authEndpoint: 'http://127.0.0.1:8000/api/broadcasting/auth',
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        $axios
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            callback(null, response.data)
          })
          .catch((error) => {
            callback(error, null)
          })
      },
    }
  },
})

export default echo
